module.exports = __webpack_public_path__ + "img/lodin.305c75b9.gif";